import { JourneyTrack } from '../journey-track';
import { TrackTypes } from '../model/track-types';
import { TrackInfo } from '../model/track-info';
import { TrackActionResult } from "../model/track-action-result";
import { MaritalStatusInvestActionV2 } from './actions/marital-status-v2-action';
import { environment } from '../../../../../../environments/environment';
import { DomainOrigin } from '../../../user-signup/model/domain-origin';

export class BasicMaritalTrackV2 extends JourneyTrack {
  readonly originalTracks = [

    new TrackInfo('marital-status', ['marital-status', 'marital-status'], undefined, {
      undefined,
      actionName: ActionList.ActionMarital
    }),
    new TrackInfo('spouse', ['marital-status', 'spouse']),
    new TrackInfo('client-data', ['data', 'client-data'], undefined, {dataOrigin: DomainOrigin[environment.registration]}),
    new TrackInfo('broker', ['broker']),
    new TrackInfo('terms', ['terms'], undefined, {dataOrigin: DomainOrigin[environment.registration]}),

  ];

  track = [];

  constructor() {
    super();
    this.track = this.originalTracks;
  }


  getTrack(): TrackInfo[] {
    return this.track;
  }

  getName(): TrackTypes {
    return TrackTypes.BASIC_V2;
  }

  async loadData() {
    throw new Error('Method not implemented.');
  }

  executeAction(actionName: any, data: any): TrackActionResult {
    return MaritalStatusInvestActionV2.execute(data, this.track);
  }

  isUncoupled() {
    return false;
  }

  isEventComunicator() {
    return false;
  }

  isBackHeader() {
    return false;
  }
}

export enum ActionList {
  ActionMarital = 'actionMarital'
}